export default {
  selectedTab: '1',
  versionProps: {
    title: '动态圆环',
    widgetNum: '2',// 每种组件的唯一编码
    version: '1',  // 每种组件的版本号
    upgrade: true,
    docUrl: '/datavisual/doc/widget'
  },
  viewProps: {
    width: '300',
    height: '300',
    top: 0,
    left: 0,
    dataConfig: {
      data: [],
    }
  },

  datasourceProps: {
    datasourceType: 'STATIC', // STATIC/API
    dataMapping: {name: 'label', value: 'value'},// key是view使用的变量名（固定）
    dataConfig: {
      'STATIC': {
        data: [
          {id: 1,label: '浦东', value: 155},
          {id: 2,label: '青浦', value: 120},
          {id: 3,label: '松江', value: 128},
          {id: 4,label: '嘉定', value: 66},
          {id: 5,label: '徐汇', value: 60},
          {id: 6,label: '静安', value: 20},
          {id: 7,label: '奉贤', value: 80}
        ]
      },
      'API': {// API时候的请求参数
        datasource: null,
        datasourceLabel: null,
        reqParams: null,
        data: null,
      },
    }
  }
}
